export default "__VITE_ASSET__c247c891__"